<div class="files-errors-content"
  [class.files-errors-content--embedded]="panelMode"
  (click)="$event.stopPropagation()">
  @if (selectedProduct) {
    @if (!product) {
      <mat-form-field class="w-full files-errors-select">
        <mat-label>{{ 'filesErrorsList'|translate }}</mat-label>
        <mat-select [(ngModel)]="selectedProduct">
          @for (product of getProductsWithErrors(); track product) {
            <mat-option [value]="product">
              {{ product.productName }} - {{ product.dimension?.description }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    }
    @if (getErrors(selectedProduct)) {
      <div class="files-errors-section">
        <strong>{{ 'order.qualityErrors.title' | translate }}</strong>
        <div class="files-errors-list">
          @for (error of getErrors(selectedProduct); track error) {
            <div class="files-errors-item">
              <div>
                <strong>{{ error.date | date:'short' : '' : translate.currentLang }} </strong> : {{ error.file }}
              </div>
              <div>{{ getErrorDescription(error.code) }}</div>
            </div>
          }
        </div>
      </div>
    }
  }
  @if (selectedProduct && order.fileCheckErrorCode !== ProcessingErrorEnum.ERROR_DETECTED && !product) {
    <mat-divider class="files-errors-divider"></mat-divider>
  }
  @if (order.fileCheckErrorCode !== ProcessingErrorEnum.ERROR_DETECTED && !product) {
    <div class="files-errors-alert">
      <div class="files-errors-alert-icon" aria-hidden="true">
        <mat-icon>error_outline</mat-icon>
      </div>
      <p class="files-errors-message">{{ order.fileCheckErrorCode | translate }}</p>
    </div>
  }
  @if (!product) {
    <button mat-flat-button color="primary" (click)="goToProofs()" class="files-errors-action">
      <mat-icon>library_add_check</mat-icon>
      <span>{{ 'ADMIN.SHOW_BAT_VIEW' | translate }}</span>
    </button>
  }
</div>
